module.exports = __webpack_public_path__ + "static/basicCostOfService_v3-8a96b1cf084325701b8f0c49eecd187d.png";